import { useEffect, useRef, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { magicLogin } from '../lib/api';
import { useAuth } from '../lib/auth';
import { Loader2, ShieldCheck, AlertTriangle } from 'lucide-react';

export default function MagicLoginPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { login } = useAuth();
  const [error, setError] = useState('');
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    (async () => {
      try {
        const res = await magicLogin(token);
        login(res.data.token, res.data.user);
        navigate('/account', { replace: true });
      } catch (e) {
        setError(e.response?.data?.detail || 'Lien invalide ou expiré.');
      }
    })();
  }, [token, login, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-rolex-green-deep px-4" data-testid="magic-login-page">
      <div className="text-center max-w-sm">
        {error ? (
          <>
            <AlertTriangle className="w-12 h-12 text-gold mx-auto mb-4" />
            <h1 className="font-display text-2xl font-bold text-cream mb-2">Oups…</h1>
            <p className="text-cream/70 text-sm mb-6">{error}</p>
            <button onClick={() => navigate('/')} className="px-6 py-3 rounded-xl bg-gold-gradient text-rolex-green font-bold text-sm" data-testid="magic-home-btn">
              Retour à l'accueil
            </button>
          </>
        ) : (
          <>
            <div className="w-14 h-14 rounded-full bg-gold/15 border border-gold/40 flex items-center justify-center mx-auto mb-4">
              <ShieldCheck className="w-7 h-7 text-gold" />
            </div>
            <Loader2 className="w-6 h-6 text-gold animate-spin mx-auto mb-3" />
            <p className="text-cream/80 text-sm">Connexion à votre espace…</p>
          </>
        )}
      </div>
    </div>
  );
}
